import { FormattedMessage } from 'react-intl'
import Flex from 'styled-flex-component'

import { useIntl } from '@context/Internationalization/useIntl'
import { SubmissionStatuses } from '@enums'
import Theme from '@theme'
import { Container, Icon } from '@tribegroup'

interface IProps {
  newStatus: SubmissionStatuses
}

const ToastTemplateSubmissionMoved: React.FC<IProps> = ({ newStatus }) => {
  const { intl } = useIntl()

  return (
    <Flex alignCenter>
      <FormattedMessage
        id="submission.toast.movedToXView"
        values={{
          b: (chunks) => <b>{chunks}</b>,
          view: intl.formatMessage({ id: `inbox.sidebar.filters.${newStatus}` }),
        }}
      />
      <Container relative height={1} width={1}>
        <Container height={1} absolute rightPosition={-0.5} topPosition={0}>
          <Icon color={Theme.defaultColor} glyph="tick" size={1} />
        </Container>
      </Container>
    </Flex>
  )
}

export default ToastTemplateSubmissionMoved
